import React from 'react';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import PortfolioTable from './PortfolioTable';
import SearchBox from 'jsx/elements/inputs/SearchBox';
import Button from 'jsx/elements/buttons/Button';
import { useToggle } from 'jsx/hooks';
import { formatNumber } from 'utils/number';

import ExcelExportButton from './ExcelExportButton';
import PortfolioFilter from './PortfolioFilter';
import CustomDropDown from 'jsx/elements/buttons/CustomDropDown';
import Flex from 'jsx/layout/Flex';

export default function PortfolioCollection({
  updateFilter,
  filters,
  onSearch,
  search,
  customers,
  showFilters,
  resultSize,
  monitorItems,
  selectedMonitor,
}) {
  const [open, toggleOpen] = useToggle(true);
  const { t } = useLocale();
  return (
    <>
      <div className="dashboard-section-header gutter-top">
        {/* <h1>{t('portfolio_title')}</h1> */}

        <Flex>
          {monitorItems.length > 1 && selectedMonitor && (
            <CustomDropDown title={selectedMonitor.name} items={monitorItems} />
          )}
          <div>
            {customers && (
              <div style={{ marginLeft: 10 }}>
                <ExcelExportButton
                  style={{ marginLeft: '10px' }}
                  customers={customers}
                  selectedMonitor={selectedMonitor}
                />
              </div>
            )}
          </div>
        </Flex>
      </div>

      {showFilters && (
        <div className="grid gutter-top gutter-bottom">
          <div className="col s4of12">
            <SearchBox
              onChange={onSearch}
              placeholder={t('portfolio_searchbox_placeholder')}
              value={search}
            />
          </div>
          <div className="col s8of12">
            <div className="float-right">
              <Button
                onClick={toggleOpen}
                selected={open}
                icon="filter2"
                color="gray-light"
                text={t('portfolio_filter_button_text')}
                iconRight
                tooltip={t('portfolio_filter_button_tooltip')}
              />
            </div>
          </div>
        </div>
      )}
      {showFilters && (
        <PortfolioFilter updateFilter={updateFilter} filterValues={filters} isOpen={open} />
      )}
      <div className="grid">
        <div className="col s1of1 text-left" style={{ paddingTop: 13 }}>
          <span className="icon icon-info2 text-blue" style={{ marginRight: 10 }} />{' '}
          {t('creditScore_COVID_company_disclamer')} <br />
          <a href={t('creditScore_COVID_News_url')} target="_blank" rel="noopener noreferrer">
            {t('creditScore_COVID_News_link_text')}
          </a>
        </div>
      </div>
      <div className="text-semibold text-right half-spacing-bottom gutter-top">
        {t('portfolio_resultSize', formatNumber(Number(resultSize)))}
      </div>
      <PortfolioTable customers={customers} />
    </>
  );
}
